import { UserSquareIcon } from "../../assets";
import type { StatusOption } from "../../types";
import styles from "./status-card.module.css";

type StatusCardProps = {
  value?: string | boolean;
  label: string;
  options: StatusOption[];
};

const StatusCard = ({ value, label, options }: StatusCardProps) => {
  const item = options.find((entry) => entry.option === value);
  const text = item ? item.text : "*";
  const style = item ? item.style : "*";

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <img width={32} height={32} src={UserSquareIcon} alt="status-icon" />
        <p className={styles.label}>{label}</p>
      </div>

      <div className={style}>
        <p className={styles.valueText}>{text}</p>
      </div>
    </div>
  );
};

export default StatusCard;
